import { ContainerAbstract } from '@hatiolab/things-scene'
import { getPopupData } from '@fmsim/api'

import { MCSStatusMixin, MCSStatusMixinProperties } from './features/mcs-status-mixin'
import { LEGEND_UNIT, Legend } from './features/mcs-status-default'
import { ParentObjectMixin, ParentObjectMixinProperties } from './features/parent-object-mixin'

/**
 * MCS용 Unit들의 공통 속성을 정의한 오브젝트
 */
export default class MCSUnit extends MCSStatusMixin(ParentObjectMixin(ContainerAbstract)) {
  static get properties(): any {
    return [...MCSStatusMixinProperties, ...ParentObjectMixinProperties]
  }

  get showMoveHandle() {
    return false
  }

  /**
   * id 후보를 조회할 때 백엔드에 보낼 타입명. 값이 있으면 검색(lookup) 대상.
   * 기본은 자기 타입. 특수 케이스는 override.
   */
  get idLookupType(): string | undefined {
    return this.state.type
  }

  get hasTextProperty() {
    return true
  }

  get decorators() {
    return ['decotag']
  }

  getTheme() {
    const { legendName } = this.state

    if (legendName) {
      return (this.root as any)?.style?.[legendName]
    }
  }

  get status() {
    return this.data?.STATUS
  }

  get auxStatus() {
    return this.data?.STATUS
  }

  get legend(): Legend {
    return this.getTheme() || this.getLegendFallback()
  }

  get auxLegend() {
    return this.legend
  }

  getLegendFallback() {
    return LEGEND_UNIT
  }

  /**
   * 2D 에서는 state.alpha 무시. hidden/모델링 dim 흐림은 코어(draw)가 일괄 처리 (MCSMachine 동일).
   */
  prerender(ctx: any) {
    super.prerender(ctx)
    ctx.globalAlpha = 1 - this._delta.fade
  }

  contains(x, y) {
    var { left, top, width, height, lineWidth = 0 } = this.state
    var extend = lineWidth / 2

    return (
      x < Math.max(left + width, left) + extend &&
      x > Math.min(left + width, left) - extend &&
      y < Math.max(top + height, top) + extend &&
      y > Math.min(top + height, top) - extend
    )
  }

  set path(path) {
    var left_top = path[0]
    var right_bottom = path[2]

    this.set({
      left: left_top.x,
      top: left_top.y,
      width: right_bottom.x - left_top.x,
      height: right_bottom.y - left_top.y
    })
  }

  get path() {
    var { left = 0, top = 0, width = 0, height = 0 } = this.state

    return [
      {
        x: left,
        y: top
      },
      {
        x: left + width,
        y: top
      },
      {
        x: left + width,
        y: top + height
      },
      {
        x: left,
        y: top + height
      }
    ]
  }

  async detailInfo() {
    const { type, id } = this.state

    if (!id) {
      return
    }

    return await getPopupData(type, id)
  }
}
